import { z } from 'zod';
export const claimQuestReviewQueuedSchema = z.object({
    claimedQuestId: z.string(),
    communityId: z.string(),
    userId: z.string(),
    subdomain: z.string(),
});
